export function getMaskedContact(value) {
  if (/^\d+$/.test(value)) {
    return value.replace(/^(\d{2})\d+(\d{4})$/, '**$2')
  }

  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
    const [user, domain] = value.split('@')
    const maskedUser = `${user[0]}**`
    return `${maskedUser}@${domain}`
  }

  return value
}
